import { CustomTemplatedMessageVariables } from 'generated-graphql/types';
import {
  SourcingSharedCustomizeMessageEmailFormData,
  SourcingSharedCustomizeMessageSmsFormData
} from 'modules/sourcing-shared/forms';
import { fillTemplatedMessage } from 'utils/fillTemplatedMessage';
import { ReviewInvitationsCandidateItem } from 'modules/sourcing-shared/shared-steps';
import { CampaignCreationSharedJobInformationFormData } from 'modules/campaign-creation-shared/forms';

type GetSourcingSharedSubjectMessageProps = {
  customizeMessageFormData:
    | SourcingSharedCustomizeMessageEmailFormData
    | SourcingSharedCustomizeMessageSmsFormData;
  candidate: ReviewInvitationsCandidateItem;
  jobInformationFormData: CampaignCreationSharedJobInformationFormData;
  jobPostingUrl: string | null;
  candidateRelevance?: string;
  organizationName: string;
};

export const getSourcingSharedSubjectMessage = ({
  customizeMessageFormData,
  candidate,
  jobInformationFormData,
  jobPostingUrl,
  candidateRelevance,
  organizationName
}: GetSourcingSharedSubjectMessageProps): string => {
  if (candidate.customInvitationMessage) {
    return candidate.customInvitationMessage;
  }

  const templateVariables = [
    {
      value: CustomTemplatedMessageVariables.CandidateFirstName,
      label: candidate.fullName.split(' ')[0]
    },
    {
      value: CustomTemplatedMessageVariables.CandidateLastName,
      label: candidate.fullName.split(' ').slice(1).join(' ')
    },
    {
      value: CustomTemplatedMessageVariables.JobTitle,
      label: jobInformationFormData?.jobTitle ?? ''
    },
    {
      value: CustomTemplatedMessageVariables.Location,
      label: jobInformationFormData?.location ?? ''
    },
    {
      value: CustomTemplatedMessageVariables.OrganizationName,
      label: organizationName
    },
    {
      value: CustomTemplatedMessageVariables.EmployerName,
      label: jobInformationFormData?.employerName ?? ''
    },
    {
      value: CustomTemplatedMessageVariables.JobApplicationUrl,
      label: jobPostingUrl || ''
    },
    {
      value: CustomTemplatedMessageVariables.AgentName,
      label: customizeMessageFormData?.agent.name ?? ''
    },
    {
      value: CustomTemplatedMessageVariables.CandidateRelevance,
      label: candidateRelevance ?? ''
    }
  ];

  const filledSubject = fillTemplatedMessage(
    customizeMessageFormData?.customTemplatedMessage ?? '',
    templateVariables
  );

  return filledSubject;
};
